import React from 'react';
import PropTypes from 'prop-types';
import { TitleLockupTitle } from '@vds/type-lockups';
import styled from 'styled-components';
import { isMobile } from '../Helpers';

const HeaderWrapper = styled.div`
  ${({ bold }) => `
  h1{
    font-weight: ${bold ? 'bold' : '400'};
 
  };
  `}
  ${({ width }) => `
  max-width: ${width};
`}
`;

const Heading = (props) => {
  // eslint-disable-next-line react/prop-types
  const { width, heading, size, ...otherProps } = props;
  const finalProps = { ...otherProps, ...(heading ? { children: heading } : {}) };
  if (!size) {
    finalProps.size = isMobile() ? 'titleLarge' : 'titleXLarge';
  } else {
    finalProps.size = size;
  }
  return (
    <HeaderWrapper {...props}>
      <TitleLockupTitle {...finalProps} />
    </HeaderWrapper>
  );
};

Heading.defaultProps = {
  bold: false,
};

Heading.propTypes = {
  width: PropTypes.string,
  size: PropTypes.string,
  bold: PropTypes.bool,
  className: PropTypes.string,
};

export default Heading;
